/**
 * Legacy `Layout` теперь делегирует на современный `UnvLayout`,
 * чтобы все страницы (MainPage, TasksPage, …) получили:
 *  - sidebar по ролям (для sysadmin/rectorate — все пункты),
 *  - корректную тёмную тему через CSS-переменные,
 *  - адекватный размер логотипа и контролов в шапке.
 *
 * Если страница уже отрендерена внутри UnvLayout (через
 * `ProtectedRoute` auto-wrap), Layout не дублирует обёртку,
 * а просто отдаёт children.
 */
import { useInLayout } from '../LayoutContext'
import UnvLayout from '../UnvLayout/UnvLayout'

function Layout({ children, title }) {
  const inLayout = useInLayout()
  if (inLayout) return <>{children}</>
  return <UnvLayout title={title}>{children}</UnvLayout>
}

export default Layout
